 
  
 
// export const LOGIN_DOMAIN = "http://localhost:3000";
// export const LOGOUT = "http://localhost:3000";
 
// export const LOGIN_DOMAIN = "https://desmdp.ap.gov.in";
// export const LOGOUT = "https://desmdp.ap.gov.in";
 

// export const ICS_DOMAIN = "https://desagriculture.ap.gov.in";
// export const TRAS_DOMAIN = "https://desagriculture.ap.gov.in"; 
// export const RAIN_DOMAIN = "https://desagriculture.ap.gov.in";
// export const YIELD_DOMAIN = "https://desagriculture.ap.gov.in";
// export const AS2 = "https://desagriculture.ap.gov.in";
export const VIS_DOMAIN ="https://desagriculture.ap.gov.in";

export const AREA_STATISTICS = "https://desagriculture.ap.gov.in";



export const BUSINESSREG_DOMAIN ="https://desindustries.ap.gov.in";
export const ASI_DOMAIN = "https://desindustries.ap.gov.in";
export const IIP_DOMAIN = "https://desindustries.ap.gov.in";

export const PRICE_STATISTICS= "https://desservices.ap.gov.in";
export const SLAP_DOMAIN = "https://desservices.ap.gov.in";
// export const MDP= "https://desservices.ap.gov.in";

export const ADMIN_DOMAIN = "https://desadmin.ap.gov.in";

// export const login_url = "https://desmdp.ap.gov.in/deslogin/";



 
export const live_url ="https://api.deswaterbody.apcfss.in/deswaterbody";
 
// export const login_url = "http://172.16.119.67:8081/des/";


 



export const LOGIN_DOMAIN = "https://descfsslogin.dev.nidhi.apcfss.in";
export const LOGOUT = "https://descfsslogin.dev.nidhi.apcfss.in";












 
 
 
//  export const LOGIN_DOMAIN = "https://egovapi.dev.nidhi.apcfss.in/des";
//  export const LOGOUT = "https://egovapi.dev.nidhi.apcfss.in/des";
 
//Agriculture Domains
export const RAIN_DOMAIN = "https://descfssrainfall.dev.nidhi.apcfss.in";
export const TRAS_DOMAIN = "https://descfssrainfall.dev.nidhi.apcfss.in";
export const AS2 = "https://descfssrainfall.dev.nidhi.apcfss.in";
export const ICS_DOMAIN = "https://descfssrainfall.dev.nidhi.apcfss.in";
export const YIELD_DOMAIN = "https://descfssrainfall.dev.nidhi.apcfss.in";


// export const VIS_DOMAIN ="https://desagriculture.ap.gov.in";
// export const PRICE_STATISTICS ="https://desagriculture.ap.gov.in";
 
// export const IIP_DOMAIN = "https://descfssiip.dev.nidhi.apcfss.in";
// export const SLAP_DOMAIN = "https://descfssslap.dev.nidhi.apcfss.in";
// export const BUSINESSREG_DOMAIN ="https://descfssbr.dev.nidhi.apcfss.in";
// export const ASI_DOMAIN = "https://descfssasi.dev.nidhi.apcfss.in";
// export const AREA_STATISTICS = "https://descfssrainfall.dev.nidhi.apcfss.in";
export const MDP= "https://desmdp.dev.nidhi.apcfss.in";

// export const ADMIN_DOMAIN = "https://descfssics.dev.nidhi.apcfss.in";

 
export const login_url = "https://egovapi.dev.nidhi.apcfss.in/des/";
 
// export const final_url = login_url;